import {DataBase} from './data-base';
import {jsonArrayMember, jsonMember, jsonObject} from 'typedjson';
import {DataTuplaDescription} from './data-tupla-description';
import {DataRow} from './data-row';
import {DateRange} from '../Utility/date-range';

@jsonObject
export class DataSeries extends DataBase {
  @jsonMember
  private description: string;
  @jsonMember
  private unit: string;
  @jsonArrayMember(DataTuplaDescription)
  private columnsDescription: DataTuplaDescription[] = [];
  @jsonArrayMember(DataRow)
  private rows: DataRow[] = [];
  @jsonMember
  private firstValue: number = null;

  // Range null = not setted
  private rangeMin: number = null;
  private rangeMax: number = null;

  // true  = fixed series: is composed of 2 points. In chart is represented by a line and in case of compare mantaing the same value
  private fixedSeries = false;

  // specific color for series
  private color: string = null;

  // indicate the idrows that generate this series
  private idRowsOrigin: string[] = null;

  set IdRowsOrigin(value: string[]) {
    this.idRowsOrigin = value;
  }
  get IdRowsOrigin(): string[] {
    return this.idRowsOrigin;
  }

  set FirstValue(value: number) {
    this.firstValue = value;
  }
  get FirstValue(): number {
    if (this.firstValue !== null) {
      return this.firstValue;
    }
    // get first value from rows
    if (this.rows.length === 0) {
      return null;
    }
    const firstRow = this.rows[0];
    const firstTupla = firstRow.getDataTupla('Close');
    if (firstTupla === undefined) {
      return null;
    }
    return firstTupla.Value;
  }
  get Color(): string {
    return this.color;
  }

  set Color(value: string) {
    this.color = value;
  }
  get FixedSeries(): boolean {
    return this.fixedSeries;
  }

  set FixedSeries(value: boolean) {
    this.fixedSeries = value;
  }

  get Units(): string {
    return this.unit;
  }

  set Units(value: string) {
    this.unit = value;
  }

  get Description(): string {
    return this.description;
  }
  set Description(value: string) {
    this.description = value;
  }

  get TuplasDescription(): DataTuplaDescription[] {
    return this.columnsDescription;
  }
  set TuplasDescription(value: DataTuplaDescription[]) {
    this.columnsDescription = value;
  }
  get DataRows(): DataRow[] {
    return this.rows;
  }

  set DataRows(value: DataRow[]) {
    this.rows = value;
  }

  get RangeMin(): number {
    return this.rangeMin;
  }

  set RangeMin(value: number) {
    this.rangeMin = value;
  }

  get RangeMax(): number {
    return this.rangeMax;
  }

  set RangeMax(value: number) {
    this.rangeMax = value;
  }

  /**
   * Get Tupla Description by Id
   * @param id Tupla Id
   */
  public getTuplaDescriptionById(id: string): DataTuplaDescription {
    return this.columnsDescription.find((tupla: DataTuplaDescription) => {
      return tupla.Id === id;
    });
  }
  public filterByDateRange(dateRange: DateRange): DataSeries {
    const result = new DataSeries();
    result.Description = this.Description;
    result.Units = this.Units;
    result.Color = this.Color;
    result.TuplasDescription = this.TuplasDescription;
    if (this.getTuplaDescriptionById('Timestamp') === undefined || dateRange === undefined) {
      result.DataRows = this.DataRows.filter((row: DataRow) => {
        return true;
      });
      return result;
    }

    // tslint:disable-next-line:max-line-length
    // todo: se la series contiente solo 2 row bisogna mantenere le 2 row impostando la data di inizio e fine come da dateRange ... e se è una series normale ma con soli 2 punti ? ... bisogna fare un controllo
    result.DataRows = this.DataRows.filter((row: DataRow) => {
      // get Timestamp tupla
      const timestampTupla = row.getDataTupla('Timestamp');

      return dateRange.isDateInRange(timestampTupla.Value);
    });
    return result;
  }

  public getMinValue(): number {
    let result = Number.MAX_VALUE;
    this.DataRows.forEach((row: DataRow) => {
      const tupla = row.getDataTupla('Close');
      if (tupla !== undefined) {
        const value = tupla.Value;
        if (value < result) {
          result = value;
        }
      }
    });
    return result;
  }

  public getMaxValue(): number {
    let result = Number.MIN_VALUE;
    this.DataRows.forEach((row: DataRow) => {
      const tupla = row.getDataTupla('Close');
      if (tupla !== undefined) {
        const value = tupla.Value;
        if (value > result) {
          result = value;
        }
      }
    });
    return result;
  }
}
